/**
    商品列表
**/
<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">商品咨询</h3>
    <el-row >
        <el-col :span="24">
            <p class="titleHeader">我的提问 （{{adviceLength}}）</p>
        </el-col>
      <el-col v-for="(item,index) in goodsAdviceList" :key="item.id">
        <el-row :gutter="20">
            <el-col :span="6">
                <div class="wholeInfoBox">
                    <div>
                        <el-image class="goodsImg" :src="item.images" @click="$router.push(`/goodsdetail?id=${item.goodsId}`)">
                        <div slot="error" class="image-slot">
                            <i class="el-icon-picture-outline"></i>
                        </div>
                        </el-image>
                        <div class="goodsText">
                        <router-link :to="`/goodsdetail?id=${item.goodsId}`">
                            <p class="OneLineDisplay">{{ item.goodsName }}</p>
                        </router-link>
                        <!-- <p style="color:#78b942">{{ item.realprice }} 元</p> -->
                        </div>
                    </div>
                </div>
            </el-col>
            <el-col :span="6">
                <p>{{index+1}}</p>
            </el-col>
            <el-col :span="6">
                <p class="OneLineDisplay">{{item.content}}</p>
                <!-- <p class="OneLineDisplay">在的</p> -->
            </el-col>
            <el-col :span="6">
                <p class="OneLineDisplay">{{item.createTime}}</p>
            </el-col>
            <el-col :span="24">
                 <el-divider></el-divider>
            </el-col>
        </el-row>
      </el-col>
      <el-col v-if="adviceLength == 0 ? true : false">
        <div class="no_goods">
          <el-image :src="require('@/assets/img/no_goods.png')" fit="fill">
            <div slot="error" class="image-slot">
              <i class="el-icon-picture-outline"></i>
            </div>
          </el-image>
          <p>暂无您的商品咨询</p>
          <p>可以去看看哪些想咨询的</p>
          <router-link to="/"
            ><p class="OneLineDisplay">随便逛逛</p></router-link
          >
        </div>
      </el-col>
    </el-row>   
  </div>
</template>
<script>
// import goodsCard from '@/components/goodsCard'
import {goodsAdvice,addgoodsAdvice} from "@/api/xunyou";
export default {
  data() {
    return {
      goodsAdviceList: [
      ],
      adviceLength:0,
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
    };
  },
 // 注册组件
  // components: {goodsCard},
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    this.getGoodsAdvice()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
       // -------------- 商品咨询 开始 -------------------------//
         getGoodsAdvice() {
            goodsAdvice({
              uid:this.userInfo.userId||'',
            })
              .then((res) => {
                  if (res.code == 0) {
                    this.goodsAdviceList = res.rows
                    this.adviceLength = this.goodsAdviceList.length
                    this.goodsAdviceList.forEach((item)=>{
                      if(item.images!=null&&item.images!='')
                      {
                        item.images=item.images.split(',')[0]
                      }
                    })
                }
              })
              .catch((err) => {
                this.$message.error("查询商品列表失败，请稍后再试！");
              });
          },

          // 提问
          // advisoryHandle(){
          //   if(this.userInfo.userId==undefined){
          //     this.$message.error("请登录！");
          //     setTimeout(()=>{
          //       this.$router.push('/login')
          //     },2000)
          //     return
          // }
          //   if(this.inputContent == ''){
          //     this.$message({
          //       type: 'info',
          //       message: '请输入提问内容'
          //     })
          //     return
          //   }
          //   addgoodsAdvice({
          //     goodsId:this.$route.query.id||'',
          //     content:this.inputContent,
          //     uid:this.userInfo.userId
          //   })
          //     .then((res) => {
          //         if (res.code == 0) {
          //           this.getGoodsAdvice()
          //           this.inputContent = ''
          //           this.centerDialogVisible = true;
          //       }
          //     })
          //     .catch((err) => {              
          //       this.$message.error("查询商品列表失败，请稍后再试！");
          //     });
              
          // },
      // -------------------- 商品咨询 结束 ----------------------------------//

  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
    margin-bottom: 20px;
  }
  .titleHeader{
      font-size: 16px;
      color: #666;
      padding-bottom: 5px;
      border-bottom: 1px solid #ccc;
      margin-bottom: 20px;
  }
  /deep/.el-tabs--border-card {
    border: 0px;
    box-shadow: unset;
    .el-tabs__header {
      border-bottom: 0px;
      background: white;
      /deep/ .el-tabs__item.is-active {
        color: #78b942;
        background-color: transparent;
        border-right-color: transparent;
        border-left-color: transparent;
      }
    }
  }

 .wholeInfoBox {    
    width: 90%;
    height: auto;
    // border: 1px solid #e4e4e4;
    padding: 0 20px;
    box-sizing: border-box;
    position: relative;
    .goodsImg{
      width:120px;
      height:120px;
      .image-slot {
          text-align: center;
          position: relative;
          top: 50%;
      }
    }
    .attentiontOpreate {
      display: none;
      position: absolute;
      right: 10px;
      top: 10px;
      .el-button--warning {
        color: #fff;
        background-color: rgba(0, 0, 0, 0.4);
        font-size: 16px;
        border-color: transparent;
        display: block;
        margin-left: 0 !important;
        margin-bottom: 10px;
      }
    }
    .el-el-image {
      width: 100%;
      height: auto;
    }
    .goodsText {
      text-align: center;
      margin-bottom: 4px;
    }
    .mark {
      display: none;
      font-size: 14px;
      background: rgba(255, 255, 255, 0.8);
      position: relative;
      .redeemNow {
        background: #78b942;
        padding: 6px;
        text-align: center;
        color: white;
        cursor: pointer;
        position: absolute;
        left: 50%;
        transform: translate(-50%);
        border-radius: 6px;
      }
      .redeemNow:hover {
        background-color: rgba(34, 34, 34, 0.85);
      }
    }
  }
  .wholeInfoBox:hover {
    .attentiontOpreate {
      display: block;
      cursor: pointer;
    }
    .el-button--warning:hover {
      background: #78b942;
    }
  }
 

  .no_goods {
    text-align: center;
    line-height: 24px;
    font-size: 14px;
  }
}
// }
</style>

 
 

 


// WEBPACK FOOTER //
// src/views/myOrder/customerService/consultation.vue